import { c as _c } from "react/compiler-runtime";
import { Image } from '@/app/components/media/image';
import type { RearBodyItem } from '@/app/cv/components/sections/products/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface ThumbItemProps {
  item: RearBodyItem;
  index: number;
  isActive: boolean;
  svgSrc?: string;
  onThumbClick: (index: number) => void;
}
interface ThumbTitleProps {
  title: string;
  isActive?: boolean;
}
const ThumbTitle = t0 => {
  const $ = _c(8);
  const {
    title,
    isActive: t1
  } = t0;
  const isActive = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isActive) {
    t2 = cn("font-noto-bold text-button-2 px-4 py-2 text-gray-300", {
      "text-white": isActive
    });
    $[0] = isActive;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createDataAttributes({
      test: "thumb-title"
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== title) {
    t4 = {
      __html: title
    };
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <span className={t2} {...t3} dangerouslySetInnerHTML={t4} />;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export const ThumbItem = t0 => {
  const $ = _c(26);
  const {
    item,
    index: t1,
    isActive: t2,
    svgSrc,
    onThumbClick
  } = t0;
  const index = t1 === undefined ? 0 : t1;
  const isActive = t2 === undefined ? false : t2;
  const thumbTitle = item.thumbTitle || item.title;
  const t3 = `View slide ${index}`;
  const t4 = isActive ? "true" : undefined;
  let t5;
  if ($[0] !== isActive) {
    t5 = cn("min-w-0 shrink-0 grow-0 basis-52 cursor-pointer space-y-6 py-3 text-center text-gray-300", {
      "rounded-sm bg-gray-900": isActive
    });
    $[0] = isActive;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== index || $[3] !== onThumbClick) {
    t6 = () => onThumbClick(index);
    $[2] = index;
    $[3] = onThumbClick;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = `thumb-${index}`;
  let t8;
  if ($[5] !== t7) {
    t8 = createDataAttributes({
      test: t7
    });
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== svgSrc) {
    t9 = !!svgSrc && <span className="pointer-events-none absolute top-0 left-0 z-10 w-full"><Image src={svgSrc} alt="" width={600} height={225} aspectRatio="aspect-8-3" objectFit="contain" objectPosition="top" sizes="(min-width: 1024px) 220px, 100vw" /></span>;
    $[7] = svgSrc;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== item.image || $[10] !== thumbTitle) {
    t10 = !!item.image && <Image src={item.image.src} alt={item.image.alt || thumbTitle || ""} width={600} height={225} aspectRatio="aspect-8-3" objectFit="contain" objectPosition="top" sizes="(min-width: 1024px) 220px, 100vw" />;
    $[9] = item.image;
    $[10] = thumbTitle;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t9) {
    t11 = <span className="relative block w-full">{t9}{t10}</span>;
    $[12] = t10;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== isActive || $[16] !== thumbTitle) {
    t12 = !!thumbTitle && <ThumbTitle title={thumbTitle} isActive={isActive} />;
    $[15] = isActive;
    $[16] = thumbTitle;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t12 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t8) {
    t13 = <button type="button" aria-label={t3} aria-current={t4} className={t5} onClick={t6} {...t8}>{t11}{t12}</button>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};